import { render } from "./attr.vue?vue&type=template&id=1925f4e0"
import script from "./attr.vue?vue&type=script&lang=js"
export * from "./attr.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__